import { FormikErrors, FormikTouched, setNestedObjectValues } from 'formik'

/**
 * Runs Formik's validateForm and only calls onValid() when the form actually
 * passes validation. Otherwise, marks every errored field as touched (so the
 * inline field-level error UI shows) and surfaces a generic alert.
 *
 * Shared between create-sale.form.tsx and sale-details.form.tsx so the two
 * "confirm save" flows can't drift out of sync with each other.
 */
export const validateFormOrAlert = async <T>(
    validateForm: () => Promise<FormikErrors<T>>,
    setTouched: (touched: FormikTouched<T>, shouldValidate?: boolean) => void,
    alertError: (message: string) => void,
    onValid: () => void
) => {
    const errors = await validateForm()
    if (Object.keys(errors).length === 0) {
        onValid()
    } else {
        setTouched(setNestedObjectValues(errors, true))
        alertError(
            'Existem campos por preencher ou com erros. Por favor verifique o formulário.'
        )
    }
}
